export default "__VITE_ASSET__d7a102e7__"